import { DocumentNode } from 'graphql';
import { gql, SubscriptionHookOptions, useSubscription } from '@apollo/client';
import { IMessageSchema } from '../../type/message';
import { IChatroomSchema } from '../../type/chatroom';

export interface IMessageCreatedSubscriptionFields {
  userId?: string
  companyId?: string
}


export interface IMessageCreatedSubscriptionResponseFields {
  createdMessage: IMessageSchema;
  chatroom: IChatroomSchema;
}


export function messageCreatedSubscription(fragment: string): DocumentNode {
  return gql`
        subscription messageCreated (
        $userId: String,
$companyId: String
        ) {
        messageCreated (
        userId: $userId,
companyId: $companyId
        ) {
        ...fragment
        }
        }
        fragment fragment on MessageCreatedSubscriptionResponse {
        ${fragment}
        }
    `;
}

export function useMessageCreatedSubscription<TData extends IMessageCreatedSubscriptionResponseFields>(
  fragment: string, options?: SubscriptionHookOptions<{ messageCreated: TData },
        IMessageCreatedSubscriptionFields>,
) {
  return useSubscription<{ messageCreated: TData },
      IMessageCreatedSubscriptionFields>(
        messageCreatedSubscription(fragment), options,
      );
}
